import { IconButton, InputAdornment } from '@material-ui/core';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import React, {
  ComponentProps,
  forwardRef,
  ForwardRefRenderFunction,
  useState,
} from 'react';

import { TextFieldWithoutRef } from './TextField';

const PasswordInputWithRef: ForwardRefRenderFunction<
  Pick<ComponentProps<typeof TextFieldWithoutRef>, 'inputRef'>,
  ComponentProps<typeof TextFieldWithoutRef>
> = (props, ref) => {
  const [showPassword, setShowPassword] = useState(false);

  const toggleShowPassword = () =>
    setShowPassword(showPassword => !showPassword);

  return (
    <TextFieldWithoutRef
      inputRef={ref}
      {...props}
      type={showPassword ? 'text' : 'password'}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle password visibility"
              onClick={toggleShowPassword}
              onMouseDown={toggleShowPassword}
              size="small"
              edge="end"
            >
              {showPassword ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
        ),
        ...props.InputProps,
      }}
    />
  );
};

export default forwardRef(PasswordInputWithRef);
